import React from "react";
import GuidePanel from "../GuidePanel.js";
import {
  GuideSectionLabel,
  GuideLead,
  GuideCallout,
  GuideCard,
  GuideCardGrid,
} from "../GuideBlocks.js";

const WhyMentalClarityMattersSection = ({ heading, accentIndex = 2 }) => (
  <GuidePanel sectionId="why-mental-clarity-matters" heading={heading} accentIndex={accentIndex}>
    <GuideLead>
      Many people pay a hidden cost for mental clutter without realizing it. Mental clutter consumes attention,
      adds mental load, and reduces decision quality. Over time, it affects every area of life.
    </GuideLead>
    <GuideSectionLabel>The hidden costs of mental clutter</GuideSectionLabel>
    <GuideCardGrid columns={3}>
      <GuideCard iconKey="stress" title="Overthinking" description="Replaying the same conversations repeatedly" />
      <GuideCard iconKey="thinking" title="Decision paralysis" description="Difficulty making clear choices" />
      <GuideCard iconKey="stress" title="Stress & anxiety" description="Increased emotional load" />
      <GuideCard iconKey="communication" title="Poor communication" description="Messages lost in assumption" />
      <GuideCard iconKey="stress" title="Damaged relationships" description="Conflict from unexamined stories" />
      <GuideCard iconKey="growth" title="Missed opportunities" description="Business and personal cost" />
      <GuideCard iconKey="energy" title="Decision fatigue" description="Attention consumed by repeating loops" />
      <GuideCard iconKey="thinking" title="Reduced creativity" description="Noise blocks new thinking" />
      <GuideCard iconKey="awareness" title="Lower confidence" description="Doubting without evidence" />
    </GuideCardGrid>
    <GuideSectionLabel>Why leaders need mental clarity</GuideSectionLabel>
    <GuideCallout>
      Leadership is less about having all the answers and more about making thoughtful decisions under
      uncertainty.
    </GuideCallout>
    <GuideCardGrid columns={2}>
      <GuideCard iconKey="communication" title="Avoid difficult conversations" />
      <GuideCard iconKey="stress" title="React emotionally under pressure" />
      <GuideCard iconKey="thinking" title="Delay important decisions" />
      <GuideCard iconKey="thinking" title="Micromanage others" />
      <GuideCard iconKey="communication" title="Create confusion within teams" />
    </GuideCardGrid>
    <GuideCallout variant="amber">Clear thinking creates confident leadership.</GuideCallout>
  </GuidePanel>
);

export default WhyMentalClarityMattersSection;
